import { z } from 'zod';
import { Navigate, useNavigate, useSearchParams } from 'react-router';
import { useAuthStore } from '@/state/auth.state';
import { Button, Card, Input, PasswordInput, Stack, Center, Group } from '@mantine/core';
import { TelegramLoginButton } from '@/common/telegram-login-button';
import { useForm } from '@mantine/form';
import { zod4Resolver } from 'mantine-form-zod-resolver';
import { authControllerSignIn, AuthRequestBodyDto } from '@/api-client/api';
import { useMutation } from '@tanstack/react-query';

type TForm = {
    login: string;
    password: string;
}

export default function SignInPage({ onSuccessSignIn }: { onSuccessSignIn: () => void }) {
    const navigate = useNavigate();
    const [ searchParams ] = useSearchParams();
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const setIsAuthenticated = useAuthStore((state) => state.setIsAuthenticated);

    const { mutate, isPending } = useMutation({
        mutationFn: async ({ fields }: { fields: AuthRequestBodyDto }) => authControllerSignIn(fields),
        onSuccess(response) {
            if (response.success) {
                localStorage.setItem('session', response.token!);
                setIsAuthenticated(true);
                onSuccessSignIn();
                
                setTimeout(() => {
                    navigate(searchParams.get('back') || '/');
                }, 300);
            } else {
                form.setErrors({
                    password: response.error,
                });
            }
        },
        onError(error: any) {
            form.setErrors({
                password: error.message,
            });
        },
    })
    
    const form = useForm<TForm>({
        mode: 'uncontrolled',
        initialValues: {
            login: '',
            password: '',
        },
        validate: zod4Resolver(
            z.object({
                login: z.string().nonempty(),
                password: z.string().nonempty(),
            }).required(),
        ),
    });
    
    async function onSubmit(fields: TForm) {
        mutate({ fields });
    }
    
    if (isAuthenticated) {
        return (
            <Navigate to={searchParams.get('back') || '/'} replace/>
        )
    }
    
    return (
        <>
            <title>Say quack, quack!</title>
            <Center style={ {
                width: '100vw',
                height: '100vh',
            } }>
                <Card title='Say quack, quack!' style={ { minWidth: 360 } }>
                    <form onSubmit={ form.onSubmit(onSubmit) } noValidate>
                        <Stack
                            align='stretch'
                            justify='center'
                        >
                            <Input.Wrapper label='Username'>
                                <Input
                                    key={ form.key('login') }
                                    { ...form.getInputProps('login') }
                                    required
                                />
                            </Input.Wrapper>
                            
                            <Input.Wrapper label='Password'>
                                <PasswordInput
                                    key={ form.key('password') }
                                    { ...form.getInputProps('password') }
                                    required
                                />
                            </Input.Wrapper>
                            <Group>
                                <Button type='submit' loading={ isPending }>
                                    Submit
                                </Button>
                                <TelegramLoginButton
                                    dataOnauth={ (user) => {
                                        console.log('Here we are', user)
                                    } }
                                    botName='spy_duck_support_bot'
                                    buttonSize='medium'
                                    dataAuthUrl={ `https://quack327.spy-duck.com/tg-auth?back=${ searchParams.get('back') || '/' }` }
                                    lang='en'
                                    widgetVersion='22'
                                />
                            </Group>
                        </Stack>
                    </form>
                </Card>
            </Center>
        </>
    )
}